import type { ReactNode } from 'react';
import { Text } from '@gravity-ui/uikit';

/**
 * Страница входа: знак и подпись продукта над формой. Подпись «Админка
 * платформы» — намеренно: два приложения на одном бренде, и сотрудник должен
 * видеть, куда вводит пароль, до того как его ввёл.
 */
export function EntryPage({
  title,
  hint,
  product,
  children,
}: {
  title: string;
  hint?: string;
  product: string;
  children: ReactNode;
}) {
  return (
    <main className="flex min-h-full items-center justify-center bg-[#f6f5f2] px-4 py-10">
      <div className="flex w-full max-w-[400px] flex-col gap-6">
        <div className="flex items-center gap-2.5">
          <img src="/icons/icon-64.png" alt="" width={32} height={32} className="size-8" />
          <div className="flex flex-col">
            <Text variant="subheader-3">Odonix</Text>
            <Text variant="caption-2" color="secondary">
              {product}
            </Text>
          </div>
        </div>
        <div className="flex flex-col gap-5 rounded-2xl border border-[var(--g-color-line-generic)] bg-[var(--g-color-base-background)] p-6 shadow-[0_8px_28px_rgba(40,41,45,0.06)]">
          <div className="flex flex-col gap-1">
            <Text as="h1" variant="header-1">
              {title}
            </Text>
            {hint === undefined ? null : <Text color="secondary">{hint}</Text>}
          </div>
          {children}
        </div>
      </div>
    </main>
  );
}
